(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('@babel/runtime/helpers/classCallCheck'), require('@babel/runtime/helpers/createClass'), require('lodash'), require('@rsksmart/rbank-controller'), require('@rsksmart/rbank-market'), require('@rsksmart/rbank-utils')) :
  typeof define === 'function' && define.amd ? define(['@babel/runtime/helpers/classCallCheck', '@babel/runtime/helpers/createClass', 'lodash', '@rsksmart/rbank-controller', '@rsksmart/rbank-market', '@rsksmart/rbank-utils'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.rbank = factory(global._classCallCheck, global._createClass, global._, global.Controller, global.Market, global.rbankUtils));
}(this, (function (_classCallCheck, _createClass, _, Controller, Market, rbankUtils) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
  var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
  var ___default = /*#__PURE__*/_interopDefaultLegacy(_);
  var Controller__default = /*#__PURE__*/_interopDefaultLegacy(Controller);
  var Market__default = /*#__PURE__*/_interopDefaultLegacy(Market);

  var Rbank = function () {
    function Rbank() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        1337: {
          httpProvider: 'http://127.0.0.1:8545',
          wsProvider: 'ws://127.0.0.1:8545'
        }
      };
      _classCallCheck__default['default'](this, Rbank);
      this.Controller = Controller__default['default'];
      this.Market = Market__default['default'];
      this.Token = Market__default['default'].Token;
      this.config = config;
      this.web3 = rbankUtils.web3;
      this.internalController = null;
    }
    _createClass__default['default'](Rbank, [{
      key: "markets",
      value: function markets() {
        var _this = this;
        return this.internalController.eventualMarketListSize.then(function (marketListSize) {
          return ___default['default'].range(marketListSize);
        }).then(function (marketIdxs) {
          return marketIdxs.map(function (marketIdx) {
            return _this.internalController.getEventualMarketAddress(marketIdx);
          });
        }).then(function (eventualMarketAddresses) {
          return Promise.all(eventualMarketAddresses);
        }).then(function (marketAddresses) {
          return marketAddresses.map(function (marketAddress) {
            return new Market__default['default'](marketAddress, _this.config);
          });
        });
      }
    }, {
      key: "eventualMarket",
      value: function eventualMarket(id) {
        var _this2 = this;
        return new Promise(function (resolve, reject) {
          if (typeof id === 'string') {
            _this2.markets().then(function (markets) {
              return markets.filter(function (market) {
                return market.address === id;
              }).pop();
            }).then(function (result) {
              if (result === undefined) {
                throw new Error('There is no market with that address');
              }
              return result;
            }).then(resolve).catch(reject);
          }
          return _this2.markets().then(function (markets) {
            return markets[id];
          }).then(function (result) {
            if (result === undefined) {
              throw new Error('There is no market at this index');
            }
            return result;
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "marketExistsByToken",
      value: function marketExistsByToken(tokenAddress) {
        var _this3 = this;
        return new Promise(function (resolve) {
          _this3.internalController.getEventualMarketAddressByToken(tokenAddress).then(function () {
            return resolve(true);
          }).catch(function () {
            return resolve(false);
          });
        });
      }
    }, {
      key: "controller",
      get: function get() {
        return this.internalController;
      }
      ,
      set: function set(controllerAddress) {
        this.internalController = new this.Controller(controllerAddress, this.config);
        this.markets();
      }
    }, {
      key: "eventualMarkets",
      get: function get() {
        return this.markets();
      }
    }]);
    return Rbank;
  }();

  return Rbank;

})));
